// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","filtersContainer":"App_filtersContainer__OfSKP","tableContainer":"App_tableContainer__lcmxs"};